/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContratFichierGridDto } from './ContratFichierGridDto';
import {
    ContratFichierGridDtoFromJSON,
    ContratFichierGridDtoFromJSONTyped,
    ContratFichierGridDtoToJSON,
} from './ContratFichierGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContratFichierGridDtoPaginatedResults
 */
export interface ContratFichierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContratFichierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContratFichierGridDto>}
     * @memberof ContratFichierGridDtoPaginatedResults
     */
    results?: Array<ContratFichierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContratFichierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContratFichierGridDtoPaginatedResults interface.
 */
export function instanceOfContratFichierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratFichierGridDtoPaginatedResultsFromJSON(json: any): ContratFichierGridDtoPaginatedResults {
    return ContratFichierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContratFichierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratFichierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContratFichierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContratFichierGridDtoPaginatedResultsToJSON(value?: ContratFichierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContratFichierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

